export default [
  {
    url: "/petugas",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
    accesses: [
      'general', 'loket_laperon', 'information', 'super_admin', 'care_operator', 'admin_creative'
    ]
  },
  {
    url: '/petugas/care',
    name: 'MPP Care',
    icon: 'UsersIcon',
    i18n: 'care',
    slug: 'care',
    show: true,
    accesses: [
      'general', 'loket_laperon', 'information', 'super_admin', 'care_operator'
    ],
    tagColor: 'primary',
    tag: true,
    tagUrl: '/app/secure/complaint-verification/total-data',
    submenu: [
      {
        url: '/petugas/care',
        name: 'Verifikasi',
        icon: 'EditIcon',
        i18n: 'care',
        slug: 'care',
        show: true,
      },
      {
        url: '/petugas/care-info',
        name: 'Info Care',
        icon: 'FileIcon',
        i18n: 'care-info',
        slug: 'care-info',
        show: true,
      },
    ]
  },
  {
    url: "/petugas/loket",
    name: "Loket",
    slug: "loket",
    icon: "PhoneCallIcon",
    accesses: [
      'general', 'loket_laperon', 'care_operator'
    ]
  },
  {
    url: "/petugas/antrian",
    name: "History Antrian",
    slug: "History antrian",
    icon: "LayersIcon",
    accesses: [
      'general', 'loket_laperon', 'information', 'care_operator'
    ]
  },
  {
    url: "/petugas/registrasi",
    name: "Registrasi",
    slug: "registrasi",
    icon: "CheckCircleIcon",
    accesses: [
      'information'
    ]
  },
  {
    url: "/petugas/manajemen-cluster",
    name: "Manajemen Cluster",
    slug: "cluster",
    icon: "ClockIcon",
    accesses: [
      'information'
    ]
  },
  {
    url: "/petugas/users",
    name: "Pengguna",
    slug: "users",
    icon: "UserIcon",
    accesses: [
      'super_admin'
    ]
  },
  {
    url: "/petugas/customers",
    name: "Pemohon",
    slug: "users",
    icon: "UserIcon",
    accesses: [
      'super_admin'
    ]
  },
  {
    url: "/petugas/agencies",
    name: "Dinas Tergabung",
    slug: "agencies",
    icon: "LayersIcon",
    accesses: [
      'super_admin'
    ]
  },
  {
    url: "/petugas/counter",
    name: "Loket",
    slug: "counters",
    icon: "PhoneCallIcon",
    accesses: [
      'super_admin'
    ]
  },
  {
    url: "/petugas/criteria",
    name: "Kriteria Rating",
    slug: "criteria",
    icon: "StarIcon",
    accesses: [
      'super_admin'
    ]
  },
  {
    url: "/petugas/disable-date",
    name: "Hari Libur",
    slug: "hari-libur",
    icon: "CalendarIcon",
    accesses: [
      'super_admin'
    ]
  },
  {
    url: "/petugas/devices",
    name: "Devices",
    slug: "devices",
    icon: "CopyIcon",
    accesses: [
      'super_admin'
    ]
  },
  {
    url: "/petugas/display-announcement",
    name: "Display Pengumuman",
    slug: "display-announcement",
    icon: "InfoIcon",
    accesses: [
      'super_admin', 'admin_creative'
    ]
  },
  {
    url: "/petugas/display-media",
    name: "Display Media",
    slug: "display-media",
    icon: "InfoIcon",
    accesses: [
      'super_admin', 'admin_creative'
    ]
  },
  // {
  //   url: "/petugas/track",
  //   name: "TRACK",
  //   slug: "track",
  //   icon: "AlertCircleIcon",
  //   accesses: [
  //     'general', 'loket_laperon', 'information', 'super_admin', 'care_operator', 'admin_creative'
  //   ]
  // },
  // {
  //   url: "/petugas/buku-tamu",
  //   name: "Buku Tamu",
  //   slug: "buku-tamu",
  //   icon: "BookIcon",
  //   accesses: [
  //     'general', 'loket_laperon', 'information', 'care_operator'
  //   ]
  // },
  // {
  //   url: "/petugas/riwayat",
  //   name: "History Buku Tamu",
  //   slug: "riwayat",
  //   icon: "FileIcon",
  // },

  // {
  //   url: '/petugas/attendance',
  //   name: 'Presensi MPP',
  //   icon: 'ClockIcon',
  //   i18n: 'attendance',
  //   slug: 'attendance',
  //   show: true,
  //   accesses: [
  //     'general', 'loket_laperon', 'information', 'super_admin', 'care_operator'
  //   ],
  //   tagColor: 'primary',
  //   tag: true,
  //   submenu: [
  //     {
  //       url: '/petugas/attendance',
  //       name: 'Presensi Petugas',
  //       icon: 'EditIcon',
  //       i18n: 'attendance',
  //       slug: 'attendance',
  //       show: true,
  //     },
  //     {
  //       url: '/petugas/attendance-report',
  //       name: 'Laporan Presensi',
  //       icon: 'FileIcon',
  //       i18n: 'attendance-report',
  //       slug: 'attendance-report',
  //       show: true,
  //     },
  //   ]
  // },
]